import { forwardRef, ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Button.module.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  shape?: 'regular' | 'round';
  color?: 'primary' | 'secondary' | 'transparent' | 'gray';
  size?: 'small' | 'medium';
  className?: string;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      shape = 'regular',
      color = 'primary',
      size = 'medium',
      className,
      children,
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      {...props}
      className={classNames(
        styles.root,
        {
          [styles.regular]: shape === 'regular',
          [styles.primary]: color === 'primary',
          [styles.secondary]: color === 'secondary',
          [styles.transparent]: color === 'transparent',
          [styles.gray]: color === 'gray',
          [styles.roundSmall]: shape === 'round' && size === 'small',
          [styles.roundMedium]: shape === 'round' && size === 'medium',
        },
        className,
      )}
    >
      {children}
    </button>
  ),
);
